import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './main.css';
import { LAST_VISIT_HREF_SESSION_ITEM } from '@assetmark/ewm30-routing-shell';
/**
 * Hack to store last visit href in the sessionStorage before the router is initialized.
 */
if (window && window.sessionStorage) {
    window.sessionStorage.setItem(LAST_VISIT_HREF_SESSION_ITEM, window.location.href);
}
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('container')).render(_jsx(App, {}));
/**
 * This code is used to expose the shared scope to the window object,
 * which is very useful for debugging purposes.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.DEBUG_SHARED_SCOPE = __webpack_require__.S.default;
reportWebVitals();
